import { forwardRef as reactForwardRef } from "react";
import { Button, ButtonProps, useColorModeValue } from "@chakra-ui/react";

export default function AttributeButton({ children, disabled, variant, ...rest }: ButtonProps) {
  const color = useColorModeValue("valueBlack.DEFAULT", "var(--chakra-colors-whiteAlpha-900)");
  const disabledColor = useColorModeValue("gray.400", "gray.500");
  const bgHover = useColorModeValue("editableBackgroundGrey.light", "cdsGrey.700");
  return (
    <Button
      disabled={disabled}
      variant={variant || "unstyled"}
      height="32px !important"
      paddingTop="0 !important"
      color={disabled ? disabledColor : color}
      justifyContent="flex-start"
      fontWeight="normal"
      minW="unset"
      w="auto"
      paddingX="8px !important"
      _hover={{
        ...(disabled ? {} : { bg: bgHover }),
      }}
      cursor={disabled ? "default" : "pointer"}
      {...rest}
    >
      {children}
    </Button>
  );
}

export const AttributeButtonWithRef = reactForwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, disabled, variant, ...rest }, ref) => {
    const color = useColorModeValue("valueBlack.DEFAULT", "var(--chakra-colors-whiteAlpha-900)");
    const bgHover = useColorModeValue("editableBackgroundGrey.light", "cdsGrey.700");

    return (
      <Button
        ref={ref}
        disabled={disabled}
        variant={variant || "unstyled"}
        height="32px !important"
        paddingTop="0 !important"
        paddingLeft="2 !important"
        color={color}
        justifyContent="flex-start"
        fontWeight="normal"
        minW="unset"
        w="auto"
        paddingX="8px !important"
        _hover={{
          ...(disabled ? {} : { bg: bgHover }),
        }}
        cursor={disabled ? "default" : "pointer"}
        {...rest}
      >
        {children}
      </Button>
    );
  },
);

AttributeButtonWithRef.displayName = "AttributeButton";
